/**
 * Typed client for `/payroll-svc/*`. Operations are typed against
 * `openapi.types.ts` (generated from the backend's `api/openapi.yaml`);
 * the contract-sync workflow fails the build if anything we call here
 * drifts from the spec.
 *
 * Auth: every call uses the shared `httpClient` instance, which attaches a
 * Cognito ID token via `fetchAuthSession()` before each request and
 * redirects to `/sign-in` on 401.
 */
import { httpClient } from '@/api/httpClient';
import type { components, operations } from '@/api/openapi.types';

export type Payroll = components['schemas']['PayrollResponse'];
export type PayrollStatus = NonNullable<Payroll['Status']>;
export type InProgressSummary = components['schemas']['InProgressSummaryResponse'];

export type ListPayrollsQuery = NonNullable<operations['listPayrolls']['parameters']['query']>;

export async function listPayrolls(
  employerId: string,
  query: ListPayrollsQuery = {},
): Promise<Payroll[]> {
  if (!employerId) throw new Error('employerId is required');
  const { data } = await httpClient.get<Payroll[]>(
    `/payroll-svc/employers/${employerId}/payrolls`,
    { params: query },
  );
  return data;
}

export async function getInProgressSummary(
  employerId: string,
  payrollId: string,
): Promise<InProgressSummary> {
  if (!employerId) throw new Error('employerId is required');
  if (!payrollId) throw new Error('payrollId is required');
  const { data } = await httpClient.get<InProgressSummary>(
    `/payroll-svc/employers/${employerId}/payrolls/${payrollId}/in-progress-summary`,
  );
  return data;
}
